<div class="flex flex-column align-items-center">
  <!--img src="assets/images/JMeleon_Logo_2021.png" alt="jmeleon-logo" class="pt-4 w-20rem"/-->
  <div class="text-center flex flex-column gap-4 pt-4">
    <div>
      <p-table
        [value]="licenseInfos"
        styleClass="p-datatable-sm"
        autoLayout="true"
        responsiveLayout="scroll"
        data-cy="build-info-dialog-license-info-table"
      >
        <ng-template pTemplate="caption"> License Information </ng-template>
        <ng-template pTemplate="header"> </ng-template>
        <ng-template pTemplate="body" let-licenseInfo>
          <tr>
            <td>{{ licenseInfo.field }}</td>
            <td>{{ licenseInfo.value }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div>
      <p-table
        [value]="systemInfos"
        styleClass="p-datatable-sm"
        autoLayout="true"
        responsiveLayout="scroll"
        data-cy="build-info-dialog-system-info-table"
      >
        <ng-template pTemplate="caption"> System Information </ng-template>
        <ng-template pTemplate="header"> </ng-template>
        <ng-template pTemplate="body" let-systemInfo>
          <tr>
            <td>{{ systemInfo.field }}</td>
            <td>{{ systemInfo.value }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div
      class="pt-5 mt-4 flex flex-column text-lg border-none border-top-1 border-solid surface-border"
      data-cy="build-info-dialog-company-info"
    >
      <b>{{ company.name }}</b>
      <span>{{ company.street }}, {{ company.city }}</span>
      <span>{{ company.email }}</span>
    </div>
  </div>
</div>
